import './bootstrap';

import $ from 'jquery';
window.$ = window.jQuery = $;

require('select2');

  
// import Alpine from 'alpinejs';

// window.Alpine = Alpine;

// Alpine.start();

$(document).ready(function() {
    $('select').select2();
    $.ajaxSetup({
      headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });
});